import { SearchModalProps } from "./searchModalState"
import { SearchModalWidget } from "./searchModalWidget"

export const SearchModal = (props: SearchModalProps) => SearchModalWidget(props).run(_ => {})
